import React, { FC } from 'react';
import './Space.css';
import '../styles/styles.css'

interface SpaceProps {
  showOn?: 'compact' | 'compact medium' | 'medium expanded' | 'medium' | 'expanded'
}

const Space: FC<SpaceProps> & {
  NewSection: FC<SpaceProps>;
  Grow: FC<SpaceProps>;
  Content: FC<SpaceProps>;
} = () => {
  return null;
};

const styledSpace = (variant: string): FC<SpaceProps> => {
  const StyledComponent: FC<SpaceProps> = ({
    showOn
  }) => {

    const showOnSplit = showOn?.split(" ").map(word => `showOn${word.charAt(0).toUpperCase() + word.slice(1)}`)
    const className = `space-${variant} ${showOn ? showOnSplit : ''}`;

    return <div className={className.trim()} />;

  };

  StyledComponent.displayName = `Space.${variant
    .split('-')
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join('')}`; // Converts kebab-case to PascalCase: "new-section" -> "Space.NewSection"

  return StyledComponent;
};

Space.NewSection = styledSpace('new-section');
Space.Grow = styledSpace('grow');
Space.Content = styledSpace('content');

export { Space };
